export const TIPO_LABEL = { MATERIALE: "Materiali", MANODOPERA: "Manodopera", NOLO: "Noli e attrezzature" };
export const TIPO_CLS = {
  MATERIALE: "bg-sky-50 text-sky-800 border-sky-200",
  MANODOPERA: "bg-violet-50 text-violet-800 border-violet-200",
  NOLO: "bg-orange-50 text-orange-800 border-orange-200",
};
export const AZIONE_LABEL = { CREA: "Creata", MODIFICA: "Modificata", ANNULLA: "Annullata", RIPRISTINA: "Ripristinata", VERIFICA: "Quantità verificata", VERIFICA_RIMOSSA: "Verifica rimossa", CRITERIO_MDO: "Criterio economico" };
import { FUNZ } from "@/components/salE5/labels";

export const canEditRegistro = (user) => FUNZ.attive && !!user && (user.role === "ADMIN" || user.role === "TECNICO");
